import { render, staticRenderFns } from "./QuestionsAndAnswers.vue?vue&type=template&id=6797943c&scoped=true"
import script from "./QuestionsAndAnswers.vue?vue&type=script&lang=js"
export * from "./QuestionsAndAnswers.vue?vue&type=script&lang=js"
import style0 from "./QuestionsAndAnswers.vue?vue&type=style&index=0&id=6797943c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6797943c",
  null
  
)

export default component.exports